import React from "react";
import {useUpdateHeaderTitle, usePermission} from "../hooks";
import {ExtraButtons} from "../components/extra-buttons";
import {Header} from "../components/layout/header";
import styled from "styled-components";
import {Table as AntTable} from "antd";
import {useGetClients, useManageItems, useGetNotificationClients, useManageNotifications} from "src/pages-lib/clients/model";
import {getColumns} from "src/pages-lib/clients/table-columns";
import {getFormattedItems} from "src/pages-lib/clients/model/use-manage-items";
import {VisibilityProvider} from "src/components/visibility-provider";
import {EditDrawer} from "src/pages-lib/clients/edit-drawer";
import {Button} from "../components/actions/button";
import {PushDrawer} from "../pages-lib/clients/push-drawer";
import {ClientsFilters} from "../pages-lib/clients/filters";
import {GetExpandedRow} from "../pages-lib/clients/sub-column";
import {NotificationsDrawer} from "../pages-lib/clients/notifications-drawer";
import {getUserTasks, sendOrderUserUpdate} from "../utils";
import {SendPromoCodeDrawer} from "../pages-lib/clients/send-promocode";
import {UserPromocodesDrawer} from "../pages-lib/clients/user-promocodes-drawer";
import {UserRewardsDrawer} from "../pages-lib/clients/user-rewards-drawer";
import {YearResultsDrawer} from "../pages-lib/clients/year-results-drawer";
import {AccessDrawer} from "../pages-lib/clients/access-drawer";
import {CardsDrawer} from "../pages-lib/clients/cards-drawer";
import {SessionsDrawer} from "../pages-lib/clients/sessions-drawer";



export default function Clients() {
    const { hasPermission, hasAnyPermission } = usePermission()
    const [createDrawerState, setCreateDrawerState] = React.useState(false);
    const [editDrawerState, setEditDrawerState] = React.useState(false);
    const [pushDrawerState, setPushDrawerState] = React.useState(false);
    const [notificationDrawerState, setNotificationDrawerState] = React.useState(false);
    const [pushAllDrawerState, setPushAllDrawerState] = React.useState(false);
    const [promoCodesDrawerState, setPromoCodesDrawerState] = React.useState(false);
    const [promoCodesViewDrawerState, setPromoCodesViewDrawerState] = React.useState(false);
    const [yearResultDrawerState, setYearResultDrawerState] = React.useState(false);
    const [accessDrawerState, setAccessDrawerState] = React.useState(false);
    const [accessUserId, setAccessUserId] = React.useState(null);
    const [userPromoCodeSendId, setUserPromoCodeSendId] = React.useState(null);
    const [cardsDrawerState, setCardsDrawerState] = React.useState(false);
    const [rewardsDrawerState, setRewardsDrawerState] = React.useState(false);
    const [rewardsUserId, setRewardsUserId] = React.useState(null);
    const [cardsUserId, setCardsUserId] = React.useState(null);
    const [sessionsDrawerState, setSessionsDrawerState] = React.useState(false);
    const [sessionsUserId, setSessionsUserId] = React.useState(null);

    // const [filterDrawerState, setFilterDrawerState] = React.useState(false)
    // const [sortableDrawerState, setSortableDrawerState] = React.useState(false)

    const openPromoCodeViewDrawer = () =>  {
        setPromoCodesViewDrawerState(true)
    }

    const openYearResult = () => {
        setYearResultDrawerState(true)
    }


    const { items: dataItems, refetch: getItems, isLoading, pagination, handleTableChange, handleSearchTable } = useGetClients()
    const {
        editData,
        onSaveEdit,
        onCreate,
        onDelete,
        onEditItem,
        handleClearDelete,
        handleUserTasksUpdate,
        sendUserPromoCode,
        getUserPromoCodes,
        clearUserPromoCodes,
        userPromoCodes,
        handleGetYearResults,
        clearYearResults,
        yearResultUserId,
        yearResults,
        onDeleteSubscriptions,
        getUserCardsAll,
        clearUserCards,
        userCards,
        isLoadingUserCards,
        getUserRewards,
        clearUserRewards,
        userRewards,
        isLoadingUserRewards,
        onDeleteUserSubscription,
    } = useManageItems(
        dataItems,
        getItems,
        onSuccessEdit,
        openPromoCodeViewDrawer,
        openYearResult
    );

    const TasksEnum = getUserTasks();

    const {
        notificationItems,
        notificationPagination,
        isNotificationLoading,
        getNotificationItems,
        handleNotificationTableChange,
        clearNotificationData,
    } = useGetNotificationClients()

    const headerTitle = useUpdateHeaderTitle({
        items: dataItems,
        defaultTitle: "0 Категорий",
        arrType: ["Клиент", "Клиента", "клиентов"],
    });

    const onOrderListUpdate = (id) => {
        sendOrderUserUpdate(id)
    }

    const onGetNotification = (id) => {
        getNotificationItems(id)
            .then(r => setNotificationDrawerState(true))


    }

    const onOpenClosePushDrawer = () => {
        setPushDrawerState((state) => !state)
    }

    const onOpenClosePushAllDrawer = () => {
        setPushAllDrawerState((state) => !state)
    }

    const closePromoCodeDrawer = () => {
        setPromoCodesDrawerState(false)
        setUserPromoCodeSendId(null)
    }

    const openPromoCodeDrawer = (id) => {
        setPromoCodesDrawerState(true)
        setUserPromoCodeSendId(id)
    }



    const { pushUserId, onUserPush, onSendPush, onSendPushToUser} = useManageNotifications(onOpenClosePushDrawer, onOpenClosePushAllDrawer)


    const onOpenAccess = (id) => {
        setAccessUserId(id)
        setAccessDrawerState(true)
    }

    const onOpenCards = (id) => {
        setCardsUserId(id)
        setCardsDrawerState(true)
        getUserCardsAll(id)
    }

    const onCloseCards = () => {
        setCardsDrawerState(false)
        setCardsUserId(null)
        clearUserCards()
    }

    const onOpenRewards = (id) => {
        setRewardsUserId(id)
        setRewardsDrawerState(true)
        getUserRewards(id)
    }

    const onCloseRewards = () => {
        setRewardsDrawerState(false)
        setRewardsUserId(null)
        clearUserRewards()
    }

    const onOpenSessions = (id) => {
        setSessionsUserId(id)
        setSessionsDrawerState(true)
    }

    const onCloseSessions = () => {
        setSessionsDrawerState(false)
        setSessionsUserId(null)
    }

    const columns = getColumns(
        hasPermission("clients.edit") ? onEditItem : null,
        hasPermission("clients.delete") ? onDelete : null,
        onUserPush,
        onGetNotification,
        onOrderListUpdate,
        openPromoCodeDrawer,
        getUserPromoCodes,
        handleGetYearResults,
        hasPermission("clients.delete") ? onOpenCards : null,
        hasAnyPermission(["clients-access.view", "clients-access.edit", "clients-password.edit"]) ? onOpenAccess : null,
        hasPermission("clients-sessions.view") ? onOpenSessions : null,
        hasPermission("clients.view") ? onOpenRewards : null
    );

    const closeYearResult = () => {
        setYearResultDrawerState(false)
        clearYearResults()
    }

    function onSuccessEdit() {
        setEditDrawerState(!editDrawerState);
    }

    const handleCloseNotifications = () => {
        setNotificationDrawerState(false)
        clearNotificationData()
    }

    return (
      <>
          <Header
              title={headerTitle}
              extra={
                  <ExtraButtons
                      onCreate={hasPermission("clients.create") ? () => setCreateDrawerState(!createDrawerState) : undefined}
                      // onFilter={() => setFilterDrawerState(!filterDrawerState)}
                      // onSort={() => setSortableDrawerState(!sortableDrawerState)}
                      titles={{ onCreate: "Добавить Клиента" }}
                  />
              }
          />

          {/*<StyledButton color={"#808080"} onClick={() => setPushAllDrawerState(true)} icon={<MessageOutlined style={{ fontSize: "16px"}}/>}>
              {"Отправить PUSH всем" }
          </StyledButton>*/}

          <ClientsFilters handleSearch={handleSearchTable} />


          <StyledTable
              dataSource={getFormattedItems(dataItems)}
              columns={columns}
              pagination={pagination}
              loading={isLoading}
              onChange={handleTableChange}
              expandable={{
                  expandedRowRender: (record) => <GetExpandedRow data={record} clearDelete={handleClearDelete}/>
                }}
          />

          {hasPermission("clients.create") && (
              <VisibilityProvider visible={createDrawerState}>
                  <EditDrawer
                      onSave={onCreate}
                      onClose={() => setCreateDrawerState(!createDrawerState)}
                      title={"Создание клиента"}
                      taskEnum={null}
                      onSendTasks={false}
                  />
              </VisibilityProvider>
          )}

          {hasPermission("clients.edit") && (
              <VisibilityProvider visible={editDrawerState}>
                  <EditDrawer
                      onSave={onSaveEdit}
                      onClose={() => setEditDrawerState(!editDrawerState)}
                      initialValues={editData}
                      title={"Редактирование клиента"}
                      taskEnum={TasksEnum}
                      onSendTasks={handleUserTasksUpdate}
                  />
              </VisibilityProvider>
          )}

          <VisibilityProvider visible={pushDrawerState}>
              <PushDrawer
                  onSave={onSendPushToUser}
                  onClose={() => setPushDrawerState(!pushDrawerState)}
                  title={"Отправить PUSH пользователю"}
                  idUser={pushUserId}
                  allUsers={false}
              />
          </VisibilityProvider>

          <VisibilityProvider visible={pushAllDrawerState}>
              <PushDrawer
                  onSave={onSendPush}
                  onClose={() => setPushAllDrawerState(!pushAllDrawerState)}
                  title={"Отправить PUSH всем"}
                  allUsers={true}
              />
          </VisibilityProvider>

          <VisibilityProvider visible={notificationDrawerState}>
              <NotificationsDrawer
                  onClose={() => setNotificationDrawerState(!notificationDrawerState)}
                  title={"Список уведомлений пользователя"}
                  clearData={handleCloseNotifications}
                  items={notificationItems}
                  pagination={notificationPagination}
                  onChange={handleNotificationTableChange}
                  isLoad={isNotificationLoading}
              />
          </VisibilityProvider>

          <VisibilityProvider visible={promoCodesDrawerState}>
              <SendPromoCodeDrawer
                  title={"Отправить промокод пользователю"}
                  onClose={closePromoCodeDrawer}
                  onSave={sendUserPromoCode}
                  idUser={userPromoCodeSendId}
              />
          </VisibilityProvider>

          <VisibilityProvider visible={promoCodesViewDrawerState}>
              <UserPromocodesDrawer
                  title={"Протокол использования промокодов"}
                  onClose={() => setPromoCodesViewDrawerState(false)}
                  clearData={clearUserPromoCodes}
                  items={userPromoCodes}
              />
          </VisibilityProvider>
          <VisibilityProvider visible={yearResultDrawerState}>
              <YearResultsDrawer
                  title={`Результаты года пользователя: id #${yearResultUserId}`}
                  onClose={closeYearResult}
                  initialValues={yearResults}
                  onDelete={() => console.log("delete")}
                  userId={yearResultUserId}
              />
          </VisibilityProvider>

          <VisibilityProvider visible={accessDrawerState}>
              <AccessDrawer
                  title={`Доступ и пароль: id #${accessUserId}`}
                  userId={accessUserId}
                  onClose={() => {
                      setAccessDrawerState(false)
                      setAccessUserId(null)
                  }}
              />
          </VisibilityProvider>

          <VisibilityProvider visible={rewardsDrawerState}>
              <UserRewardsDrawer
                  title={`Награды клиента: id #${rewardsUserId}`}
                  onClose={onCloseRewards}
                  items={userRewards}
                  isLoading={isLoadingUserRewards}
              />
          </VisibilityProvider>

          <VisibilityProvider visible={cardsDrawerState}>
              <CardsDrawer
                  title={`Сохранённые карты клиента: id #${cardsUserId}`}
                  userId={cardsUserId}
                  cards={userCards}
                  isLoading={isLoadingUserCards}
                  onClose={onCloseCards}
                  onRefresh={getUserCardsAll}
                  onDeleteOne={onDeleteUserSubscription}
                  onDeleteAll={onDeleteSubscriptions}
              />
          </VisibilityProvider>

          <VisibilityProvider visible={sessionsDrawerState}>
              <SessionsDrawer
                  title={`Активные сессии клиента: id #${sessionsUserId}`}
                  userId={sessionsUserId}
                  onClose={onCloseSessions}
              />
          </VisibilityProvider>
      </>
    )
}

const StyledTable = styled(AntTable)`
  .row-can-view {
    cursor: pointer;
  }
  .ant-table-row{
    background: #ffffff;
  }
  max-width: 100%;
  overflow: scroll;
`;

const StyledButton = styled(Button)`
    margin: 10px 0 20px 0 ;
`;



